module.exports = __webpack_public_path__ + "img/color-opensource.e34870c1.svg";